import * as Recoil from "recoil";
import { inProjectCreationWizardState } from "features/brm/stores/atoms-wizard";

export const useIsProjectWizardOpen = () => {
  const [isProjectWizardOpen, setIsProjectWizardOpen] = Recoil.useRecoilState(inProjectCreationWizardState);

  return { isProjectWizardOpen, setIsProjectWizardOpen };
};
